<template>
  <div v-show="show">
    <div class="main">
      <div class="actModules_btnWrap">
        <div
          class="actModules_btnItems"
          v-for="(item, index) in btnInfo"
          :key="index"
        >
          <p class="desc">{{ item.btnDesc }}</p>
          <div v-if="index === 1" class="actModules_btn" @click="appShare()">{{ item.btnName }}</div>
          <div v-else class="actModules_btn" @click="submitAddress()">{{ item.btnName }}</div>
        </div>
        <div class="testNum">
          {{ numLabel }}
          <span>{{ currentNum }}</span>
        </div>
      </div>
    </div>
    <!-- 地址填写弹窗-->
    <div class="actModal" v-show="showInfo">
      <div class="infoContent">
        <div href="javascript:;" @click="close()" class="closeBtn" />
        <div class="actModal_header">
          <h3>填写详细地址</h3>
        </div>
        <div class="innerCon">
          <ul>
            <li>
              <label class="label-pre">收货人姓名：</label>
              <input type="text" v-model="personName" />
            </li>
            <li>
              <label class="label-pre">联系电话：</label>
              <input type="text" v-model="personPhone" />
            </li>
            <li>
              <label class="label-pre">收货地址：</label>
              <input type="text" v-model="personAddr" />
            </li>
          </ul>
        </div>
        <div class="submsg" @click="submitAddress(1)">确认提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import bus from '../../../bus';
import { mixins } from '../../../src/h5mixins';
import { sharefriend } from '../lottery/index';
export default {
	name: 'h5-button',
	mixins: mixins,
	actConfig: {
		labels: {
			btnInfo: '功能按钮',
			btnDesc: '按钮功能描述',
			action: '动作',
			btnName: '按钮文案',
			showtype: '展示(1安卓,0 IOS)',
			queryList: '查询次数',
			numLabel: '查询次数描述',
		}
	},
	props: {
		btnInfo: {
			type: Array,
			default: function () {
				return [
					{
						btnDesc: '领取规则',
						h5Action: {
							class: 'action',
							type: 'no',
							value: '',
							ruleId: '',
							title: '实物地址流程'
						},
						btnName: '实物按钮'
					},
					{
						btnDesc: '分享规则',
						h5Action: {
							class: 'action',
							type: 'no',
							value: '',
							ruleId: '',
							title: '分享流程'
						},
						btnName: '分享按钮'
					}
				];
			}
		},
		queryList: {
			type: Array,
			default: function () {
				return [
					{
						h5Action: {
							class: 'action',
							type: 'no',
							title: '分享后查询流程',
							value: '',
							ruleId: '',
						}
					}
				];
			}
		},
		numLabel: {
			type: String,
			default: '剩余抽奖次数'
		},
		showtype: {
			type: String,
			default: ''
		}
	},
	data () {
		return {
			showInfo: false,
			personName: '',
			personPhone: '',
			personAddr: '',
			show: true,
			currentNum: 0,
		};
	},
	mounted () {
		bus.$on('isLogined', () => {
			this.query();
		});
		bus.$on('showtype', val => {
			this.show = val === this.showtype;
		});
	},
	methods: {
		async query () {
			const [{h5Action: { value }}] = this.queryList;
			try {
				const { res: {sOutValue1, sOutValue2, iRet} = {} } = await this.$doAction('ame', value, { sServiceType: this.$actConfig.gameCode })
				if (parseInt(iRet) === 0) {
					let lotteryNumRe = sOutValue1 - sOutValue2;
					lotteryNumRe = lotteryNumRe < 0 ? 0 : lotteryNumRe;
					this.currentNum = lotteryNumRe;
				}
			} catch (e) {
				console.log(e);
			}
		},
		appShare () {
			sharefriend(this.$actConfig.shareData, this.share)
		},
		async submitAddress (type) {
			if (type) {
				if (!this.personName) {
					alert('名字不能为空');
					return;
				} else if (!(/^1[3456789]\d{9}$/.test(this.personPhone))) {
					alert('手机号码有误，请重填');
					return;
				}
			}
			let sData = {
				iShow: type ? '0' : '1',
				sName: this.personName,
				sMobile: this.personPhone,
				sAddress: this.personAddr
			};
			const [{h5Action: { value }} = {}] = this.btnInfo;
			try {
				const {jData: {sName = '', sMobile = '', sAddress = ''} = {}, sMsg} = await this.$doAction('address', value, sData);
				this.personName = sName;
				this.personPhone = sMobile;
				this.personAddr = sAddress;
				if (type) {
					this.showInfo = false;
					alert(sMsg);
				} else {
					this.showInfo = true;
				}
			} catch (e) {
				console.log(e);
				alert(e.sMsg);
			}
		},
		close () {
			this.showInfo = false;
		},
		async share () {
			const [, {h5Action: { value }} = {}] = this.btnInfo;
			try {
				const {res: {iRet}} = await this.$doAction('ame', value, {sServiceType: this.$actConfig.gameCode});
				if (parseInt(iRet) === 0) {
					this.query();
				}
			} catch (e) {
				console.log(e)
				e.sMsg && alert(e.sMsg);
			}
		}
	}
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/common";
.desc {
  font-size: 0.24rem;
  color: #4a4a4a;
  text-align: center;
  max-width: 3.2rem;
  margin: 0 auto 0.1rem;
}
.infoContent {
  position: fixed;
  transform: translate(-50%, -50%);
  border: none;
  left: 50%;
  top: 50%;
  width: 5.3rem;
  height: 4.2rem;
  background-color: #43286b;
}
.testNum {
  font-size: 0.24rem;
  color: #4a4a4a;
  text-align: center;
}
.innerCon {
  width: 96%;
  height: 2.3rem;
  margin-left: 2%;
  margin-top: 0.5rem;
  position: relative;
}
.innerCon ul {
  width: 100%;
  height: 2.3rem;
  position: relative;
}
.innerCon ul li {
  width: 100%;
  height: 0.6rem;
  margin-top: 0.2rem;
}
.label-pre {
  font-size: 0.26rem;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/actModules/h5/templates/bottomBtn/buttOn.vue